import React from 'react';
import ReactMarkdown from 'react-markdown';

export function Usage() {
  // Global __DOCS__ is injected at build time by the inject-content Vite plugin
  const docs =
    typeof __DOCS__ !== 'undefined' ? __DOCS__ : '# Usage Guide\n\nNo documentation available.';

  return (
    <div>
      <h2>Usage Guide</h2>
      <ReactMarkdown>{docs}</ReactMarkdown>
    </div>
  );
}
